import type { ICognitoStorage } from 'amazon-cognito-identity-js';

/* eslint-disable class-methods-use-this */
export default class SessionStorage implements ICognitoStorage {
  private static instance: SessionStorage | null = null;

  public static getInstance(): SessionStorage {
    SessionStorage.instance ??= new SessionStorage();

    return SessionStorage.instance;
  }

  setItem(key: string, value: string): void {
    window.sessionStorage.setItem(key, value);
  }

  getItem(key: string): string | null {
    const item = window.sessionStorage.getItem(key);
    return item;
  }

  removeItem(key: string): void {
    window.sessionStorage.removeItem(key);
  }

  clear(): void {
    window.sessionStorage.clear();
  }
}
